import { MapContentLayer } from '../MapContentLayer';
import {LayerSpecification, SymbolLayerSpecification} from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapStyles } from '../../../../../configuration/map-styles';
import { MapPreviewComponent } from '../../map-preview.component';

export class ShiftMarkerSymbolLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('shift-marker-symbol-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'symbol',
      source: this.sourceRef.sourceId,
      layout: {
        'icon-image': [
          'case',
          ['boolean', ['get', 'vehicle']],
          MapPreviewComponent.AZIMUTH_IMAGE,
          MapPreviewComponent.FLAG_IMAGE,
        ],
        'icon-rotate':  [
          'case',
          ['boolean', ['get', 'vehicle']],
          ['get', 'heading'],
          0,
        ],
        'icon-allow-overlap': false,
        'symbol-sort-key': [
          'case',
          ['boolean', ['get', 'vehicle']],
          0,
          [
            'case',
            ['boolean', ['get', 'start']],
            2,
            1,
          ]
        ],
        'icon-size': [
          'case',
          ['boolean', ['get', 'vehicle']],
          0.18,
          1,
        ],
        'icon-rotation-alignment': 'map',
      },
      paint: {
        'icon-color': [
          'case',
          ['boolean', ['get', 'vehicle']],
          MapStyles.PAUSED_COLOR,
          [
            'case',
            ['boolean', ['get', 'start']],
            MapStyles.SHIFT_START_COLOR,
            MapStyles.SHIFT_END_COLOR,
          ]
        ],
        'icon-halo-width': 0,
      },
    } as SymbolLayerSpecification;
  }

}
